<ng-container *ngIf="user$ | async as _user">
	<div class="menu-item px-5">
		<div class="menu-content d-flex align-items-center px-3">
			<span class="round symbol-label font-size-h5 fw-bold text-primary d-flex align-items-center justify-content-center me-4 p-3">
				{{ _user.name | initials }}
			</span>
			<div class="d-flex flex-column">
				<div class="fw-bolder d-flex align-items-center fs-5">
					{{ _user.firstname }} {{ _user.lastname }}
					@if (isPayAdmin) {
						<span class="badge badge-light-primary fw-bolder fs-8 px-2 py-2 ms-2 mb-1">Admin</span>
					}
				</div>
				<span class="fw-bold text-muted fs-7">
					{{ _user.email }}
				</span>
			</div>
		</div>
	</div>

	<div class="separator my-2"></div>

	<div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="bottom">
		<a class="menu-link px-5 cursor-pointer">
			<span class="menu-title position-relative" translate>
				language_header_navbar
				<span class="text-gray-600 ms-auto d-inline-flex align-items-center fs-9 px-3 py-2">
					{{ language.name | translate }}{{ ' ' }}
					<img class="w-15px h-15px rounded-1 ms-2" [src]="language.flag" alt="metronic" />
				</span>
			</span>
		</a>

		<div class="menu-sub menu-sub-dropdown w-175px py-4">
			<div *ngFor="let l of langs" class="menu-item px-3 cursor-pointer" (click)="selectLanguage(l.lang)" (keydown.enter)="selectLanguage(l.lang)" tabindex="0">
				<a class="menu-link d-flex px-5" [ngClass]="l.lang === language.lang ? 'active' : ''">
					<span class="symbol symbol-20px me-4">
						<img class="rounded-1" [src]="l.flag" alt="metronic" />
					</span>
					{{ l.name | translate }}
				</a>
			</div>
		</div>
	</div>

	<div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="bottom">
		<a class="menu-link px-5 cursor-pointer">
			<span class="menu-title position-relative" translate>
				theme_mode_header_navbar
				<span class="fs-8 px-3 py-2 position-absolute translate-middle-y top-50 end-0">
					<app-theme-mode-switcher [toggleBtnClass]="btnClass" toggleBtnClass="{`btn-active-light-primary btn-custom ${toolbarButtonHeightClass}`}"></app-theme-mode-switcher>
				</span>
			</span>
		</a>
	</div>

	<div class="separator my-2"></div>

	<div class="menu-item px-5 my-1">
		<a href="https://accounts.spotside.com/realms/spotside/account/" target="_blank" (click)="onLinkClick($event)" class="menu-link px-5" translate>account_manage_header_navbar</a>
	</div>

	<div class="menu-item px-5">
		<a (click)="logout()" (keydown.enter)="logout()" tabindex="0" class="menu-link px-5 cursor-pointer" translate>sign_out_header_navbar</a>
	</div>
</ng-container>
